<template>
  <article>
    <main class="body" role="main" id="main">
      <header-video v-if="isVideo && isParams" :fields="fields" :params="params"/>
      <header-image v-else :fields="fields"/>
      <white-board :fields="fields"/>
      <sc-placeholder :rendering="rendering" name="digital-house-editorial-block"/>
      <note-footer :fields="fields"/>
    </main>
  </article>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'
import EditorialComponent from '../../editorial-component/index'
import WhiteBoard from '../../white-board/index'
import HeaderImage from '../../header-image-editorial/index'
import NoteFooter from '../../note-footer/index'
import HeaderVideo from '../../header-video-editorial'
import { detailTypes } from './detail-types'

export default {
  name: 'NoteDetails',
  head () {
    return {
      title: this.$t('META_TITLE_CINEMA_DETAILS', { name: this.fields.title.value }),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('META_DESCRIPTION_CONTENT') }
      ]
    }
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVideo () {
      return this.params.mode === detailTypes.VIDEO
    },
    isParams () {
      return this.params
    }
  },
  components: {
    scPlaceholder: Placeholder,
    EditorialComponent,
    WhiteBoard,
    HeaderImage,
    NoteFooter,
    HeaderVideo
  }
}
</script>

<style lang="scss" scoped>
::v-deep .page-header button.back {
  position: static;
}
</style>
